import {createReducer, PayloadAction} from "@reduxjs/toolkit";


import reducerStatuses from "../../status";
import {
  ADD,
  ADMISSION_COLLEGE_AND_EXECUTOR, ADMISSION_COLLEGES,
  ADMISSION_DOCUMENT,
  ADMISSION_EDUCATION, ADMISSION_EDUCATION_ORDER_XML, ADMISSION_EMAIL,
  ADMISSION_ENTRANT_APPLICATIONS, ADMISSION_ENTRANT_INFO,
  ADMISSION_EXAM,
  ADMISSION_EXECUTOR_EGOV_APPLICATION,
  ADMISSION_FOUR_SPECIALITIES_ARRAY,
  ADMISSION_FOUR_SPECIALITIES_DATA,
  ADMISSION_GENERAL_CONTEST,
  ADMISSION_GENERAL_CONTEST_CHANGE_STATUS,
  ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER,
  ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST, ADMISSION_GENERAL_CONTEST_TRANSFER_TO_COLLEGE,
  ADMISSION_GENERAL_CONTEST_WITH_QUOTES,
  ADMISSION_GROUPS,
  ADMISSION_IIN,
  ADMISSION_INFO,
  ADMISSION_LANGUAGES,
  ADMISSION_LESSON,
  ADMISSION_LOG,
  ADMISSION_MARKS,
  ADMISSION_NEW_MARK,
  ADMISSION_ORDER,
  ADMISSION_PROFILE,
  ADMISSION_PROVINCES,
  ADMISSION_REASON,
  ADMISSION_STATUS,
  ADMISSION_STEPS_DATA,
  ADMISSION_STUDENT_LIST,
  ADMISSION_TOTAL,
  DELETE,
  DONE,
  EDIT,
  FAIL,
  FETCH,
  GET,
  HANDLE, POST,
  RESET,
  RESULT,
  SET, SPECIALITIES,
  STUDY
} from "../../constants";


const initialState = {
  educationOrder: {
    ...reducerStatuses,
    data: null as any
  },
  arrayOfSpecialities: {
    data: [] as any
  },
  collegeForArrayOfSpecialities: {
    data: [] as any
  },
  stepsData: {
    ...reducerStatuses,
    data: null as any
  },
  arrayOfSpecialitiesDataFromApi: {
    ...reducerStatuses,
    data: [] as any
  },
  provinces: {
    ...reducerStatuses,
    data: null as any
  },
  checkIin: {
    ...reducerStatuses,
    data: null as any
  },
  checkEmail: {
    ...reducerStatuses,
    data: null as any
  },
  getMarks: {
    ...reducerStatuses,
    data: null as any
  },
  educationDocumentRating: {
    ...reducerStatuses,
    data: null as any
  },
  examResult: {
    ...reducerStatuses,
    data: null as any
  },
  getInfo: {
    ...reducerStatuses,
    data: null as any
  },
  getStudentByEducationOrder: {
    ...reducerStatuses,
    data: null as any
  },
  groupList: {
    ...reducerStatuses,
    data: null as any
  },
  addToStudentList: {
    ...reducerStatuses,
    data: null as any
  },
  createOrder: {
    ...reducerStatuses,
    data: null as any
  },
  userOrder: {
    ...reducerStatuses,
    data: null as any
  },
  egovExecutor: {
    ...reducerStatuses,
    data: null as any
  },
  getTotalResult: {
    ...reducerStatuses,
    data: null as any
  },
  collegeAndExecutor: {
    ...reducerStatuses,
    data: null as any
  },
  entrantApplications: {
    ...reducerStatuses,
    data: null as any
  },
  admissionLog: {
    ...reducerStatuses,
    data: null as any
  },
  generalContest: {
    ...reducerStatuses,
    data: null as any
  },
  generalContestWithQuotes: {
    ...reducerStatuses,
    data: null as any
  },
  specialities: {
    ...reducerStatuses,
    data: null as any
  },
  changeEntrantStatus: {
    ...reducerStatuses,
    data: null as any
  },
  collegeListToTransfer: {
    ...reducerStatuses,
    data: null as any
  },

  //entrant-info
  entrantInfo: {
    ...reducerStatuses,
    data: null as any
  },

  //sign xml parent/entrant
  educationOrderXML: {
    ...reducerStatuses,
    data: null as any
  },
  postEducationOrderXML: {
    ...reducerStatuses,
    data: null as any
  },

}

export default createReducer(initialState, builder =>
  builder
    .addCase(ADMISSION_EDUCATION + FETCH, (state) => ({
      ...state,
      educationOrder: {
        ...initialState.educationOrder,
        loading: true,
      }
    }))
    .addCase(ADMISSION_EDUCATION + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      educationOrder: {
        ...initialState.educationOrder,
        success: true,
        data: payload.data.data.addEducationOrder
      }
    }))
    .addCase(ADMISSION_EDUCATION + FETCH + FAIL, (state) => ({
      ...state,
      educationOrder: {
        ...initialState.educationOrder,
        failed: true,
        data: state.educationOrder.data
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + FETCH, (state) => ({
      ...state,
      collegeForArrayOfSpecialities: {
        ...initialState.collegeForArrayOfSpecialities,
        loading: true,
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      collegeForArrayOfSpecialities: {
        ...initialState.collegeForArrayOfSpecialities,
        success: true,
        data: payload.data.data.qualificationColleges
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + FETCH + FAIL, (state) => ({
      ...state,
      collegeForArrayOfSpecialities: {
        ...initialState.collegeForArrayOfSpecialities,
        failed: true,
        data: null
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + RESET, (state) => ({
      ...state,
      collegeForArrayOfSpecialities: {
        ...initialState.collegeForArrayOfSpecialities,
        loading: false,
        success: false,
        failed: false,
        data: []
      }
    }))
    .addCase(ADMISSION_EDUCATION + EDIT + FETCH, (state) => ({
      ...state,
      educationOrder: {
        ...initialState.educationOrder,
        loading: true,
        data: { ...state.educationOrder.data }
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_ARRAY + FETCH, (state) => ({
      ...state,
      arrayOfSpecialities: {
        ...initialState.educationOrder,
        loading: true,
        data: [...state.arrayOfSpecialities.data]
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_ARRAY + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      arrayOfSpecialities: {
        ...initialState.educationOrder,
        success: true,
        data: [...state.arrayOfSpecialities.data, payload]
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_ARRAY + FETCH + FAIL, (state) => ({
      ...state,
      arrayOfSpecialities: {
        ...initialState.educationOrder,
        loading: true,
        data: state.arrayOfSpecialities.data
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_ARRAY + EDIT, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      arrayOfSpecialities: {
        ...initialState.educationOrder,
        success: true,
        data: state.arrayOfSpecialities.data.map((specialtyItem:any) => {
          if (specialtyItem.id === payload.id) {
            return {...specialtyItem, priority: payload.priority}
          }
          return specialtyItem
        })
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_ARRAY + DELETE, (state, {payload}: PayloadAction<any>) => {

      let filteredItems =  state.arrayOfSpecialities.data.filter((specialtyItem:any) => specialtyItem.id !== payload.id)

      const updatedItems = filteredItems.map((item:any) => ({
        ...item,
        priority: item.priority > payload.priority ? item.priority - 1 : item.priority
      }));

      return {
        ...state,
        arrayOfSpecialities: {
          ...initialState.educationOrder,
          success: true,
          data: updatedItems
        }
      }
    })
    .addCase(ADMISSION_FOUR_SPECIALITIES_ARRAY + HANDLE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      arrayOfSpecialities: {
        data: [...state.arrayOfSpecialities.data, ...payload]
      }
    }))

    .addCase(ADMISSION_FOUR_SPECIALITIES_ARRAY + RESET, (state) => ({
      ...state,
      arrayOfSpecialities: {
        ...initialState.educationOrder,
        data: []
      }
    }))

    .addCase(ADMISSION_LANGUAGES + FETCH, (state) => ({
      ...state,
      arrayOfSpecialitiesDataFromApi: {
        ...initialState.arrayOfSpecialitiesDataFromApi,
        loading: true,
      }
    }))
    .addCase(ADMISSION_LANGUAGES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      arrayOfSpecialitiesDataFromApi: {
        ...initialState.arrayOfSpecialitiesDataFromApi,
        success: true,
        data: payload.data.data
      }
    }))
    .addCase(ADMISSION_LANGUAGES + FETCH + FAIL, (state) => ({
      ...state,
      arrayOfSpecialitiesDataFromApi: {
        ...initialState.arrayOfSpecialitiesDataFromApi,
        failed: true,
        data: null
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH, (state) => ({
      ...state,
      arrayOfSpecialitiesDataFromApi: {
        ...initialState.arrayOfSpecialitiesDataFromApi,
        loading: true,
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      arrayOfSpecialitiesDataFromApi: {
        ...initialState.arrayOfSpecialitiesDataFromApi,
        success: true,
        data: payload.data.data
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH + FAIL, (state) => ({
      ...state,
      arrayOfSpecialitiesDataFromApi: {
        ...initialState.arrayOfSpecialitiesDataFromApi,
        failed: true,
        data: null
      }
    }))
    .addCase(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH + RESET, (state) => ({
      ...state,
      arrayOfSpecialitiesDataFromApi: {
        ...initialState.arrayOfSpecialitiesDataFromApi,
        failed: false,
        data: null
      }
    }))

    .addCase(ADMISSION_STEPS_DATA + SET, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      stepsData: Object.assign({}, state.stepsData, payload)
    }))

    .addCase(ADMISSION_STEPS_DATA + RESET, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      stepsData: {
        ...initialState.stepsData,
        data: null
      }
    }))

    .addCase(ADMISSION_PROVINCES + FETCH, (state) => ({
      ...state,
      provinces: {
        ...initialState.provinces,
        loading: true,
      }
    }))
    .addCase(ADMISSION_PROVINCES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      provinces: {
        ...initialState.provinces,
        success: true,
        data: payload.data.data.provinces
      }
    }))
    .addCase(ADMISSION_PROVINCES + FETCH + FAIL, (state) => ({
      ...state,
      provinces: {
        ...initialState.provinces,
        failed: true,
        data: null
      }
    }))

    .addCase(ADMISSION_EDUCATION + EDIT, (state) => ({
      ...state,
      educationOrder: {
        ...initialState.educationOrder,
        loading: true,
        data: {...state.educationOrder.data}
      }
    }))
    .addCase(ADMISSION_EDUCATION + EDIT + DONE, (state, {payload}: PayloadAction<any>) => {
      const currentPayload = payload.data.data.changeEducationOrder

      return {
        ...state,
        educationOrder: {
          loading: false,
          success: true,
          failed: false,
          data: {
            ...state.educationOrder.data,
            ...currentPayload
          }
        }
      }
    })
    .addCase(ADMISSION_EDUCATION + EDIT + FAIL, (state) => ({
      ...state,
      educationOrder: {
        ...initialState.educationOrder,
        failed: true,
      }
    }))

    .addCase(ADMISSION_IIN + FETCH, (state) => ({
      ...state,
      checkIin: {
        ...initialState.checkIin,
        loading: true,
      }
    }))
    .addCase(ADMISSION_IIN + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      checkIin: {
        ...initialState.checkIin,
        success: true,
        data: payload.data.data.checkIin
      }
    }))
    .addCase(ADMISSION_IIN + FETCH + FAIL, (state) => ({
      ...state,
      checkIin: {
        ...initialState.checkIin,
        failed: true,
        data: null
      }
    }))

    .addCase(ADMISSION_EMAIL + FETCH, (state) => ({
      ...state,
      checkEmail: {
        ...initialState.checkEmail,
        loading: true,
      }
    }))
    .addCase(ADMISSION_EMAIL + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      checkEmail: {
        ...initialState.checkEmail,
        success: true,
        data: payload.data.data.checkEmail
      }
    }))
    .addCase(ADMISSION_EMAIL + FETCH + FAIL, (state) => ({
      ...state,
      checkEmail: {
        ...initialState.checkEmail,
        failed: true,
        data: null
      }
    }))

    .addCase(ADMISSION_MARKS + FETCH, (state) => ({
      ...state,
      getMarks: {
        ...initialState.getMarks,
        loading: true,
      }
    }))
    .addCase(ADMISSION_MARKS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      getMarks: {
        ...initialState.getMarks,
        success: true,
        data: {
          educationOrder: {
            ...payload.data.data.educationOrder,
            educationDocument: {
              ...payload.data.data.educationOrder.educationDocument,
              ratings: [5, 4, 3, 2].map(item => {
                const findElement = payload.data.data.educationOrder.educationDocument.ratings.find((rating: any) => item === rating.rating)

                if(findElement){
                  return findElement
                } else {
                  return {
                    id: null,
                    education_order_id: payload.data.data.educationOrder.id,
                    count: null,
                    rating: item,
                    type: null
                  }
                }
              })
            }
          }
        }
      }
    }))
    .addCase(ADMISSION_MARKS + FETCH + FAIL, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      getMarks: {
        ...initialState.getMarks,
        failed: true,
        data: payload
      }
    }))

    .addCase(ADMISSION_LESSON + ADD + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      getMarks: {
        ...initialState.getMarks,
        success: true,
        data: {
          ...state.getMarks.data,
          educationOrder: {
            ...state.getMarks.data.educationOrder,
            markList: {
              ...state.getMarks.data.educationOrder.markList,
              commonWithRequired:
                [...state.getMarks.data.educationOrder.markList.commonWithRequired, payload.data.data.addOrChangeCustomRating]
            }
          }
        }
      }
    }))
    .addCase(ADMISSION_LESSON + ADMISSION_PROFILE + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      getMarks: {
        loading: true,
        success: false,
        failed: false,
        data: {
          ...state.getMarks.data,
          educationOrder: {
            ...state.getMarks.data.educationOrder,
            markList: {
              ...state.getMarks.data.educationOrder.markList,
              common: state.getMarks.data.educationOrder.markList.common.filter((item:any) => item.id !== payload.data.data.deleteCustomRating.id),
              profile:
                state.getMarks.data.educationOrder.markList.selectedSpeciality.map((item:any, index:any) => {
                  if (item.qualification_id === payload.data.data.deleteCustomRating.qualification_id) {
                    return {
                      ...item,
                      profileMarks: item.profileMarks.filter((item:any) => item.id !== payload.data.data.deleteCustomRating.id)
                    }
                  }
                  return item
                })
            }
          }
        }
      }
    }))
    .addCase(ADMISSION_LESSON + ADMISSION_PROFILE + ADD + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      getMarks: {
        ...initialState.getMarks,
        success: true,
        data: {
          ...state.getMarks.data,
          educationOrder: {
            ...state.getMarks.data.educationOrder,
            markList: {
              ...state.getMarks.data.educationOrder.markList,
              profile:
                state.getMarks.data.educationOrder.markList.profile.map((item:any) => {
                  if (item.qualification_id === payload.data.data.addOrChangeCustomRating.qualification_id) {
                    return {...item, profileMarks: [...item.profileMarks, payload.data.data.addOrChangeCustomRating]}
                  }

                  return item
                })
            }
          }
        }
      }
    }))
    .addCase(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + ADD + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      getMarks: {
        ...initialState.getMarks,
        success: true,
        data: {
          ...state.getMarks.data,
          educationOrder: {
            ...state.getMarks.data.educationOrder,
            selectedSpecialities: state.getMarks.data.educationOrder.selectedSpecialities.map((item:any) => {
              if(item.speciality_id === payload.speciality_id){
                return {
                  ...item,
                  [`${payload.type}Marks`]: [...item[`${payload.type}Marks`], payload]
                }
              } else {
                return item
              }
            })
          }
        }
      }
    }))
    .addCase(ADMISSION_LESSON + ADMISSION_PROFILE + DELETE + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      getMarks: {
        ...initialState.getMarks,
        success: true,
        data: {
          ...state.getMarks.data,
          educationOrder: {
            ...state.getMarks.data.educationOrder,
            selectedSpecialities: state.getMarks.data.educationOrder.selectedSpecialities.map((item:any) => {
              if(item.speciality_id === payload.speciality_id){
                return {
                  ...item,
                  [`${payload.type}Marks`]: item[`${payload.type}Marks`].filter((mark:any) => mark.id !== payload.id)
                }
              } else {
                return item
              }
            })
          }
        }
      }
    }))
    .addCase(ADMISSION_LESSON + EDIT + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      getMarks: {
        loading: false,
        success: true,
        failed: false,
        data: {
          ...state.getMarks.data,
          educationOrder: {
            ...state.getMarks.data.educationOrder,
            markList: {
              ...state.getMarks.data.educationOrder.markList,
              common:
                state.getMarks.data.educationOrder.markList.common.map((item:any) => {
                  if (item.id === payload.data.data.addOrChangeCustomRating.id) {
                    return {...item, rating: payload.data.data.addOrChangeCustomRating.rating}
                  }
                  return item
                }),
              profile:
                state.getMarks.data.educationOrder.markList.selectedSpeciality.map((item:any, index:any) => {
                  if (item.qualification_id === payload.data.data.addOrChangeCustomRating.qualification_id) {
                    return {
                      ...item,
                      profileMarks: item.profileMarks.map((item:any) => {
                        if(item.id === payload.data.data.addOrChangeCustomRating.id){
                          return {...item, rating: payload.data.data.addOrChangeCustomRating.rating}
                        }
                        return item
                      })
                    }
                  }
                  return item
                })
            }
          }
        }
      },
    }))
    .addCase(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + EDIT + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      getMarks: {
        loading: false,
        success: true,
        failed: false,
        data: {
          ...state.getMarks.data,
          educationOrder: {
            ...state.getMarks.data.educationOrder,
            selectedSpecialities: state.getMarks.data.educationOrder.selectedSpecialities.map((item:any) => {
              if(payload.type === "required"){
                return {
                  ...item,
                  requiredMarksByLang: item.requiredMarksByLang.map((mark:any) => {

                    if (mark.id === payload.id) {
                      return {
                        ...mark,
                        rating: payload.rating
                      }
                    } else {
                      return mark
                    }
                  })
                }
              }
              if(item.speciality_id === payload.speciality_id){
                return {
                  ...item,
                  [`${payload.type}Marks`]: item[`${payload.type}Marks`].map((mark:any) => {
                    if(mark.id === payload.id){
                      return {
                        ...mark,
                        rating: payload.rating,
                        subject_name: payload.subject_name,
                      }
                    } else {
                      return mark
                    }
                  })
                }
              } else {
                return item
              }
            })
          }
        }
      },
    }))
   .addCase(ADMISSION_EDUCATION + ADMISSION_DOCUMENT + ADMISSION_MARKS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {
     if (state.getInfo.data) {
       return {
         ...state,
         getInfo: {
           loading: false,
           success: true,
           failed: false,
           data: {
             educationOrder: {
               ...state.getInfo.data.educationOrder,
               educationDocument: {
                 ...state.getInfo.data.educationOrder.educationDocument,
                 count: payload.avg_count,
                 avg_rating: payload.avg_rating,
                 ratings: state.getInfo.data.educationOrder.educationDocument.ratings.map((item:any) => item.rating === payload.rating ? {
                   ...item,
                   count: payload.count
                 } : item)
               }
             }
           }
         },
       }
     } else {
       return {
         ...state,
         getMarks: {
           loading: false,
           success: true,
           failed: false,
           data: {
             educationOrder: {
               ...state.getMarks.data.educationOrder,
               educationDocument: {
                 ...state.getMarks.data.educationOrder.educationDocument,
                 count: payload.avg_count,
                 avg_rating: payload.avg_rating,
                 ratings: state.getMarks.data.educationOrder.educationDocument.ratings.map((item:any) => item.rating === payload.rating ? {
                   ...item,
                   count: payload.count
                 } : item)
               }
             }
           }
         }
       }
     }
   })

    .addCase(ADMISSION_EXAM + RESULT, (state) => ({
      ...state,
      examResult: {
        ...initialState.examResult,
        loading: true,
      }
    }))

    .addCase(ADMISSION_EXAM + RESULT + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      examResult: {
        ...initialState.examResult,
        success: true,
        data: payload.data.data
      }
    }))

    .addCase(ADMISSION_EXAM + RESULT + FAIL, (state) => ({
      ...state,
      examResult: {
        ...initialState.examResult,
        failed: true,
      }
    }))


    .addCase(SET + ADMISSION_EXAM + RESULT, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      examResult: {
        ...state.examResult,
        data: {
          ...state.examResult.data,
          educationOrder: {
            ...state.examResult.data.educationOrder,
            selectedSpecialities:
              state.examResult.data.educationOrder.selectedSpecialities.map((item:any) => {
                if (item.id === payload.id) {
                  return {...item, loading: true}
                }
                return item
              })
          }
        }
      }
    }))

    .addCase(SET + ADMISSION_EXAM + RESULT + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      examResult: {
        loading: false,
        success: true,
        failed: false,
        data: {
          ...state.examResult.data,

          educationOrder: {
            ...state.examResult.data.educationOrder,
            selectedSpecialities:
              state.examResult.data.educationOrder.selectedSpecialities.map((item:any) => {
                if (item.id === payload.id) {
                  return {...item, status: payload.status, loading: false}
                }
                return item
              })
          }
        }
      },
      getInfo: {
        loading: false,
        success: true,
        failed: false,
        data: state.getInfo.data ? {
          ...state.getInfo.data,

          educationOrder: {
            ...state.getInfo.data.educationOrder,
            selectedSpecialities:
              state.getInfo.data.educationOrder.selectedSpecialities.map((item:any) => {
                if (item.id === payload.id) {
                  return {...item, status: payload.status, loading: false}
                }
                return item
              })
          }
        } : null
      },
    }))

    .addCase(SET + ADMISSION_EXAM + ADMISSION_MARKS + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      examResult: {
        loading: true,
        success: false,
        failed: false,
        data: {
          ...state.examResult.data,
          educationOrder: {
            ...state.examResult.data.educationOrder,
            selectedSpecialities:
              state.examResult.data.educationOrder.selectedSpecialities.map((item: any) => {
                if ((item.qualification_id === payload.qualification_id) && (item.speciality_id === payload.speciality_id)) {
                  return {
                    ...item,
                    marksStep3: {
                      ...item.marksStep3,
                      examMarks: item.marksStep3.examMarks.map((mark: any) => {
                        if (mark.id === payload.id) {
                          return {...mark, rating: payload.rating}
                        } else {
                          return mark
                        }
                      })
                    }
                  }
                }
                return item
              })
          }
        }
      }
    }))

    .addCase(ADMISSION_INFO + FETCH, (state) => ({
      ...state,
      getInfo: {
        ...initialState.getInfo,
        loading: true,
      }
    }))
    .addCase(ADMISSION_INFO + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {
      const requiredMarks = payload.data.data.educationOrder.selectedSpecialities.map((item:any) => item.requiredMarksByLang)

      return {
        ...state,
        getInfo: {
          loading: false,
          success: true,
          failed: false,
          data: {
            educationOrder: {
              ...payload.data.data.educationOrder,
              markList: {
                ...payload.data.data.educationOrder.markList,
                common: [...payload.data.data.educationOrder.markList.common, ...payload.data.data.educationOrder.markList.required, ...payload.data.data.educationOrder.markList.subCommon]
              },
              educationDocument: {
                ...payload.data.data.educationOrder.educationDocument,
                ratings: [5, 4, 3, 2].map(item => {
                  const findElement = payload.data.data.educationOrder.educationDocument.ratings.find((rating:any) => item === rating.rating)

                  if(findElement){
                    return findElement
                  } else {
                    return {
                      id: null,
                      education_order_id: payload.data.data.educationOrder.id,
                      count: null,
                      rating: item,
                      type: null
                    }
                  }
                })
              }
            }
          }
        }
      }
    })
    .addCase(ADMISSION_INFO + FETCH + FAIL, (state) => ({
      ...state,
      getInfo: {
        ...initialState.getInfo,
        failed: true,
      }
    }))
    .addCase(ADMISSION_INFO + RESET, (state) => ({
      ...state,
      getInfo: {
        ...initialState.getInfo,
        data: null,
      }
    }))

    .addCase(ADMISSION_EDUCATION + ADMISSION_ORDER + GET + STUDY + FETCH, (state) => ({
      ...state,
      getStudentByEducationOrder: {
        ...initialState.getStudentByEducationOrder,
        loading: true,
      }
    }))
    .addCase(ADMISSION_EDUCATION + ADMISSION_ORDER + GET + STUDY + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      getStudentByEducationOrder: {
        ...initialState.getStudentByEducationOrder,
        success: true,
        data: payload.data
      }
    }))
    .addCase(ADMISSION_EDUCATION + ADMISSION_ORDER + GET + STUDY + FAIL, (state) => ({
      ...state,
      getStudentByEducationOrder: {
        ...initialState.getStudentByEducationOrder,
        failed: true,
      }
    }))


    .addCase(ADMISSION_GROUPS + ADMISSION_INFO, (state) => ({
      ...state,
      groupList: {
        ...initialState.groupList,
        loading: true,
      }
    }))
    .addCase(ADMISSION_GROUPS + ADMISSION_INFO + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      groupList: {
        ...initialState.groupList,
        success: true,
        data: payload.data.data
      }
    }))
    .addCase(ADMISSION_GROUPS + ADMISSION_INFO + FAIL, (state) => ({
      ...state,
      groupList: {
        ...initialState.groupList,
        failed: true,
      }
    }))

    .addCase(SET + ADMISSION_STATUS, (state) => ({
      ...state,
      getInfo: {
        loading: true,
        success: false,
        failed: false,
        data: {
          ...state.getInfo.data,
        }
      }
    }))
    .addCase(SET + ADMISSION_STATUS + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      getInfo: {
        loading: false,
        success: true,
        failed: false,
        data: {
          ...state.getInfo.data,
          educationOrder: {
            ...state.getInfo.data.educationOrder,
            status: payload.data.data.changeEducationOrderStatus.status
          },
        }
      }
    }))

    //addToStudentList
    .addCase(ADD + ADMISSION_STUDENT_LIST + FETCH, (state) => ({
      ...state,
      addToStudentList: {
        ...initialState.addToStudentList,
        loading: true,
      }
    }))
    .addCase(ADD + ADMISSION_STUDENT_LIST + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      getInfo: {
        ...initialState.addToStudentList,
        success: true,
        data: payload.data.data
      }
    }))

    .addCase(ADD + ADMISSION_ORDER + FETCH, (state) => ({
      ...state,
      createOrder: {
        ...initialState.createOrder,
        loading: true,
      }
    }))
    .addCase(ADD + ADMISSION_ORDER + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      createOrder: {
        ...initialState.createOrder,
        success: true,
        data: payload.data
      }
    }))
    .addCase(ADD + ADMISSION_ORDER + FAIL, (state) => ({
      ...state,
      createOrder: {
        ...initialState.createOrder,
        failed: true,
      }
    }))

    .addCase(ADMISSION_ORDER + FETCH, (state) => ({
      ...state,
      userOrder: {
        ...initialState.userOrder,
        loading: true,
      }
    }))
    .addCase(ADMISSION_ORDER + FETCH + DONE, (state, {payload}:any) => ({
      ...state,
      userOrder: {
        ...initialState.userOrder,
        success: true,
        data: payload
      }
    }))
    .addCase(ADMISSION_ORDER + FETCH + FAIL, (state) => ({
      ...state,
      userOrder: {
        ...initialState.userOrder,
        failed: true,
      }
    }))

    .addCase(EDIT + ADMISSION_ORDER + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      userOrder: {
        ...initialState.userOrder,
        success: true,
        data: payload
      }
    }))

    //причина отказа
    .addCase(ADMISSION_REASON + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      getInfo: {
        loading: false,
        success: true,
        failed: false,
        data: {
          ...state.getInfo.data,
          educationOrder: {
            ...state.getInfo.data.educationOrder,
            decline_reason: payload.data.data.changeEducationOrder.decline_reason
          },
        }
      }
    }))

    //Проставить исполнителя для заявки с Egov
    .addCase(ADMISSION_EXECUTOR_EGOV_APPLICATION + FETCH, (state) => ({
      ...state,
      egovExecutor: {
        ...initialState.egovExecutor,
        loading: true,
      }
    }))
    .addCase(ADMISSION_EXECUTOR_EGOV_APPLICATION + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      egovExecutor: {
        ...initialState.egovExecutor,
        success: true,
        data: payload.data.data
      }
    }))
    .addCase(ADMISSION_EXECUTOR_EGOV_APPLICATION + FETCH + FAIL, (state) => ({
      ...state,
      egovExecutor: {
        ...initialState.egovExecutor,
        failed: true,
      }
    }))

    .addCase(GET + ADMISSION_TOTAL + RESULT, (state) => ({
      ...state,
      getTotalResult: {
        ...initialState.getTotalResult,
        loading: true,
      }
    }))
    .addCase(GET + ADMISSION_TOTAL + RESULT + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      getTotalResult: {
        ...initialState.getTotalResult,
        success: true,
        data: payload.data.data
      }
    }))

    .addCase(GET + ADMISSION_TOTAL + RESULT + FAIL, (state) => ({
      ...state,
      getTotalResult: {
        ...initialState.getTotalResult,
        failed: true,
      }
    }))

    .addCase(ADMISSION_COLLEGE_AND_EXECUTOR  + FETCH, (state) => ({
      ...state,
      collegeAndExecutor: {
        ...initialState.collegeAndExecutor,
        loading: true,
      }
    }))
    .addCase(ADMISSION_COLLEGE_AND_EXECUTOR  + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      collegeAndExecutor: {
        ...initialState.collegeAndExecutor,
        success: true,
        data: payload.data.data
      }
    }))
    .addCase(ADMISSION_COLLEGE_AND_EXECUTOR  + FETCH + FAIL, (state) => ({
      ...state,
      collegeAndExecutor: {
        ...initialState.collegeAndExecutor,
        failed: true,
      }
    }))

    //admission entrant applications
      .addCase(ADMISSION_ENTRANT_APPLICATIONS + FETCH, (state) => ({
        ...state,
        entrantApplications: {
          ...initialState.entrantApplications,
          loading: true,
        }
      }))
      .addCase(ADMISSION_ENTRANT_APPLICATIONS + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
        ...state,
        entrantApplications: {
          ...initialState.entrantApplications,
          success: true,
          data: payload
        }
      }))
      .addCase(ADMISSION_ENTRANT_APPLICATIONS + FETCH + FAIL, (state) => ({
        ...state,
        entrantApplications: {
          ...initialState.entrantApplications,
          failed: true,
        }
      }))

      //admission log
      .addCase(ADMISSION_LOG + FETCH, (state) => ({
        ...state,
        admissionLog: {
          ...initialState.admissionLog,
          loading: true,
        }
      }))
      .addCase(ADMISSION_LOG + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
        ...state,
        admissionLog: {
          ...initialState.admissionLog,
          success: true,
          data: payload.data.data
        }
      }))
      .addCase(ADMISSION_LOG + FETCH + FAIL, (state) => ({
        ...state,
        admissionLog: {
          ...initialState.admissionLog,
          failed: true,
        }
      }))

    //общий конкурс
    .addCase(ADMISSION_GENERAL_CONTEST + FETCH, (state) => ({
      ...state,
      generalContest: {
        ...initialState.generalContest,
        loading: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      generalContest: {
        ...initialState.generalContest,
        success: true,
        data: payload
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST + FETCH + FAIL, (state) => ({
      ...state,
      generalContest: {
        ...initialState.generalContest,
        failed: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_WITH_QUOTES + FETCH, (state) => ({
      ...state,
      generalContestWithQuotes: {
        ...initialState.generalContestWithQuotes,
        loading: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_WITH_QUOTES + FETCH + DONE, (state, {payload}:PayloadAction<any>) => {
      Object.keys(payload).forEach((key:any, idx:any) => {
        payload[key] = payload[key].filter((item:any) => item.quota === key)
      })

      return {
        ...state,
        generalContestWithQuotes: {
          ...initialState.generalContestWithQuotes,
          success: true,
          data: {...state.generalContestWithQuotes.data, ...payload}
        }
      }
    })
    .addCase(ADMISSION_GENERAL_CONTEST_WITH_QUOTES + FETCH + FAIL, (state) => ({
      ...state,
      generalContestWithQuotes: {
        ...initialState.generalContestWithQuotes,
        failed: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + FETCH, (state) => ({
      ...state,
      specialities: {
        ...initialState.specialities,
        loading: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      specialities: {
        ...initialState.specialities,
        success: true,
        data: payload,
        applicationsAmount: payload.reduce((accum:any, obj:any) => {
          return accum + obj.amount_bids
        }, 0)
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + FETCH + FAIL, (state) => ({
      ...state,
      specialities: {
        ...initialState.specialities,
        failed: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + RESET, (state) => ({
      ...state,
      specialities: {
        ...initialState.specialities,
      },
      generalContest: {
        ...initialState.generalContest,
      },
      generalContestWithQuotes: {
        ...initialState.generalContestWithQuotes,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_CHANGE_STATUS + FETCH, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      changeEntrantStatus: {
        ...initialState.changeEntrantStatus,
        loading: true,
        data: payload
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_CHANGE_STATUS + FETCH + DONE, (state, {payload}:PayloadAction<any>) => {

      // Object.keys(state.generalContestWithQuotes.data).forEach((key, idx) => {
      //   state.generalContestWithQuotes.data[key] = state.generalContestWithQuotes.data[key].map((item:any) => {
      //     if(item.selectedSpeciality.id === state.changeEntrantStatus.data.id){
      //       item.selectedSpeciality.entrant_response = state.changeEntrantStatus.data.response
      //       item.selectedSpeciality.addon = 1
      //
      //       return {...item, entrant_response: state.changeEntrantStatus.data.response, addon: 1}
      //     } else {
      //       return item
      //     }
      //
      //   })
      // })
      console.log("payload reducer", payload)

      return {
        ...state,

        // generalContestWithQuotes: {
        //   ...state.generalContestWithQuotes,
        //   data: state.generalContestWithQuotes.data
        // },
        //todo: сделать это для каждого из типов квоты
        generalContest: {
          ...state.generalContest,
          data: state.generalContest.data.map((item:any) => {
            if (item.selectedSpeciality.id === payload.selected_speciality_id) {
              return {...item, selectedSpeciality: {...item.selectedSpeciality, entrant_response: payload.response}}
              // item.selectedSpeciality.entrant_response = state.changeEntrantStatus.data.response
              // item.status = payload.raging.status
            } else {
              return item
            }
          })
        },
        changeEntrantStatus: {
          loading: false,
          success: true,
          failed: false,
          data: payload
        },
      }
    })
    .addCase(ADMISSION_GENERAL_CONTEST_CHANGE_STATUS + FETCH + FAIL, (state) => ({
      ...state,
      changeEntrantStatus: {
        ...initialState.changeEntrantStatus,
        failed: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER + FETCH, (state) => ({
      ...state,
      collegeListToTransfer: {
        ...initialState.collegeListToTransfer,
        loading: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      collegeListToTransfer: {
        ...initialState.collegeListToTransfer,
        success: true,
        data: payload
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER + FETCH + FAIL, (state) => ({
      ...state,
      collegeListToTransfer: {
        ...initialState.collegeListToTransfer,
        failed: true,
      }
    }))
    .addCase(ADMISSION_GENERAL_CONTEST_TRANSFER_TO_COLLEGE + FETCH + DONE, (state, {payload}:PayloadAction<any>) => {
      Object.keys(state.generalContestWithQuotes.data).forEach((key:any, idx:any) => {
        state.generalContestWithQuotes.data[key] = state.generalContestWithQuotes.data[key].map((item:any) => {
          if (item.selectedSpeciality.id === payload.selected_speciality_id) {
            item.selectedSpeciality.transfer.status_confirm = payload.status_confirm
            item.selectedSpeciality.transfer.addon = 2

            return item
          }

          return item
        })
      })

      return {

        ...state,
        collegeListToTransfer: {
          loading: false,
          success: true,
          failed: false,
          data: payload
        },
        generalContest: {
          ...state.generalContest,
          data: state.generalContest.data.map((item:any) => {
            if (item.selectedSpeciality.id === payload.selected_speciality_id) {
              item.selectedSpeciality.transfer.status_confirm = payload.status_confirm
            }

            return item
          })
        }
      }

    })

    .addCase(SET + ADMISSION_STATUS + SPECIALITIES + DONE, (state, {payload}:PayloadAction<any>) => {

      return {
        ...state,
        examResult: {
          loading: false,
          success: true,
          failed: false,
          data: {
            ...state?.examResult?.data,
            educationOrder: {
              ...state?.examResult?.data?.educationOrder,
              selectedSpecialities: state?.examResult?.data?.educationOrder?.selectedSpecialities?.map((item:any) => {
                  if (item.id === payload.id) {
                    return {...item, status: payload.status}
                  }
                  return item
                })
            }
          }
        },
        getInfo: {
          loading: false,
          success: true,
          failed: false,
          data: state.getInfo.data ? {
            ...state?.getInfo?.data,
            educationOrder: {
              ...state?.getInfo?.data?.educationOrder,
              selectedSpecialities: state?.getInfo?.data?.educationOrder?.selectedSpecialities?.map((item:any) => {
                if (item.id === payload.id) {
                  return {...item, status: payload.status}
                }
                return item
              })
            }
          } : null
        },
      }
    })

    //entrant-info
    .addCase(ADMISSION_ENTRANT_INFO + FETCH, (state) => ({
      ...state,
      entrantInfo: {
        ...initialState.entrantInfo,
        loading: true,
      }
    }))
    .addCase(ADMISSION_ENTRANT_INFO + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      entrantInfo: {
        ...initialState.entrantInfo,
        success: true,
        data: payload
      }
    }))
    .addCase(ADMISSION_ENTRANT_INFO + FETCH + FAIL, (state) => ({
      ...state,
      entrantInfo: {
        ...initialState.entrantInfo,
        failed: true,
      }
    }))

    //sign xml parent/entrant
    .addCase(ADMISSION_EDUCATION_ORDER_XML + FETCH, (state) => ({
      ...state,
      educationOrderXML: {
        ...initialState.educationOrderXML,
        loading: true,
      }
    }))
    .addCase(ADMISSION_EDUCATION_ORDER_XML + FETCH + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      educationOrderXML: {
        ...initialState.educationOrderXML,
        success: true,
        data: payload
      }
    }))
    .addCase(ADMISSION_EDUCATION_ORDER_XML + FETCH + FAIL, (state) => ({
      ...state,
      educationOrderXML: {
        ...initialState.educationOrderXML,
        failed: true,
      }
    }))
    .addCase(ADMISSION_EDUCATION_ORDER_XML + POST, (state) => ({
      ...state,
      postEducationOrderXML: {
        ...initialState.postEducationOrderXML,
        loading: true,
      }
    }))
    .addCase(ADMISSION_EDUCATION_ORDER_XML + POST + DONE, (state, {payload}:PayloadAction<any>) => ({
      ...state,
      postEducationOrderXML: {
        ...initialState.postEducationOrderXML,
        success: true,
        data: payload
      }
    }))
    .addCase(ADMISSION_EDUCATION_ORDER_XML + POST + FAIL, (state) => ({
      ...state,
      postEducationOrderXML: {
        ...initialState.postEducationOrderXML,
        failed: true,
      }
    }))
    .addCase(ADMISSION_EDUCATION_ORDER_XML + POST + RESET, (state) => ({
      ...state,
      postEducationOrderXML: {
        ...initialState.postEducationOrderXML,
        loading: false,
        success: false,
        failed: false,
        data: null
      }
    }))
)